module.exports = "fragment ShippingContact on ContactType{__typename id firstName lastName email address1 address2 city zip phone1 phone2 fax title company}"